import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface NetworkMember {
  id: string;
  display_name: string;
  username: string;
  avatar_url?: string;
  title?: string;
  organization?: string;
  added_via: 'organization' | 'giblet' | 'manual';
}

export const useNetworkMembers = (userId?: string) => {
  return useQuery({
    queryKey: ['network-members', userId],
    queryFn: async () => {
      if (!userId) return [];
      
      const { data, error } = await supabase
        .from('user_networks')
        .select(`
          network_member_id,
          added_via,
          profiles!user_networks_network_member_id_fkey (
            id,
            display_name,
            username,
            avatar_url,
            title,
            organization
          )
        `)
        .eq('user_id', userId);

      if (error) throw error;

      return (data || []).map(item => ({
        id: item.profiles.id,
        display_name: item.profiles.display_name,
        username: item.profiles.username,
        avatar_url: item.profiles.avatar_url,
        title: item.profiles.title,
        organization: item.profiles.organization,
        added_via: item.added_via as 'organization' | 'giblet' | 'manual'
      })) as NetworkMember[];
    },
    enabled: !!userId
  });
};